<div *ngIf="canAccess" class="relative dashboard-box lg:col-span-2">
  <div class="absolute inset-px rounded-[16px]"></div>
  <div class="relative flex h-full flex-col overflow-hidden rounded-[16px]">

    <!-- Header -->
    <div class="px-8 sm:px-10 py-3 flex items-center justify-between dashboard-header">
      <h2 class="text-xl text-white font-semibold mb-0">Document Store (CPaaS)</h2>
      <span class="text-xs text-white/60">digitalservices.wholesale.telekom.com</span>
    </div>

    <div class="px-6 lg:px-10 py-6 flex flex-col gap-6">

      <!-- Token status -->
      <div *ngIf="accessToken" class="flex items-center gap-3 text-sm">
        <span [class]="tokenStatusClass">●</span>
        <span [class]="tokenStatusClass">{{ tokenStatusLabel }}</span>
        <button mat-stroked-button (click)="refreshAccessToken()" [disabled]="loading"
                class="!text-xs !py-0 !px-2 !h-7">
          Refrescar token
        </button>
        <button mat-stroked-button color="warn" (click)="clearSession()" [disabled]="loading"
                class="!text-xs !py-0 !px-2 !h-7">
          Cerrar sesión
        </button>
      </div>

      <!-- ── Sección 1: Autenticación ── -->
      <mat-expansion-panel [expanded]="!accessToken">
        <mat-expansion-panel-header>
          <mat-panel-title class="font-semibold">1. Autenticación</mat-panel-title>
          <mat-panel-description>OAuth2 — grant_type=password</mat-panel-description>
        </mat-expansion-panel-header>

        <div class="flex flex-col gap-4 pt-2">
          <div class="text-xs text-gray-500 bg-gray-50 rounded p-3">
            <strong>Client ID:</strong> client-32704bca-981d-4e79-b957-9e0d9ff0fc4b<br>
            <strong>Client Secret:</strong> <span class="text-gray-400">(hardcoded)</span>
          </div>

          <div class="flex flex-wrap gap-4">
            <mat-form-field class="flex-1 min-w-[180px]">
              <mat-label>Usuario (Digital Services Portal)</mat-label>
              <input matInput [(ngModel)]="username" autocomplete="username">
            </mat-form-field>
            <mat-form-field class="flex-1 min-w-[180px]">
              <mat-label>Contraseña</mat-label>
              <input matInput type="password" [(ngModel)]="password" autocomplete="current-password">
            </mat-form-field>
            <mat-form-field class="w-[140px]">
              <mat-label>OTP (si aplica)</mat-label>
              <input matInput [(ngModel)]="otp" autocomplete="one-time-code">
            </mat-form-field>
          </div>

          <div>
            <button mat-raised-button color="primary" (click)="login()" [disabled]="loading">
              <mat-spinner *ngIf="loading" diameter="18" class="inline-block mr-2"></mat-spinner>
              Iniciar sesión
            </button>
          </div>
        </div>
      </mat-expansion-panel>

      <!-- ── Sección 2: Listar ficheros ── -->
      <mat-expansion-panel [expanded]="!!accessToken">
        <mat-expansion-panel-header>
          <mat-panel-title class="font-semibold">2. Listar ficheros</mat-panel-title>
          <mat-panel-description>GET /v2/files</mat-panel-description>
        </mat-expansion-panel-header>

        <div class="flex flex-col gap-4 pt-2">

          <!-- Fila 1: fechas + categoría -->
          <div class="flex flex-wrap gap-4">
            <mat-form-field class="w-[160px]">
              <mat-label>Fecha desde</mat-label>
              <input matInput type="date" [(ngModel)]="dateCreatedFrom">
            </mat-form-field>
            <mat-form-field class="w-[160px]">
              <mat-label>Fecha hasta</mat-label>
              <input matInput type="date" [(ngModel)]="dateCreatedTo">
            </mat-form-field>
            <mat-form-field class="w-[220px]">
              <mat-label>Categoría</mat-label>
              <mat-select [(ngModel)]="category">
                <mat-option value="">— todas —</mat-option>
                <mat-option *ngFor="let c of categories" [value]="c">{{ c }}</mat-option>
              </mat-select>
            </mat-form-field>
          </div>

          <!-- Fila 2: texto libre -->
          <div class="flex flex-wrap gap-4">
            <mat-form-field class="flex-1 min-w-[200px]">
              <mat-label>Nombre contiene</mat-label>
              <input matInput [(ngModel)]="nameContains" placeholder="fragmento del nombre">
            </mat-form-field>
            <mat-form-field class="flex-1 min-w-[200px]">
              <mat-label>Descripción contiene</mat-label>
              <input matInput [(ngModel)]="descriptionContains" placeholder="fragmento de la descripción">
            </mat-form-field>
          </div>

          <!-- Fila 3: arrays -->
          <div class="flex flex-wrap gap-4">
            <mat-form-field class="flex-1 min-w-[200px]">
              <mat-label>Wholesale Customer IDs</mat-label>
              <mat-select [(ngModel)]="wholesaleCustomerIds" multiple>
                <mat-option *ngFor="let c of clientOptions" [value]="c.wholesaleCustomerId">{{ c.label }}</mat-option>
              </mat-select>
            </mat-form-field>
            <mat-form-field class="flex-1 min-w-[200px]">
              <mat-label>Service Names</mat-label>
              <input matInput [(ngModel)]="serviceNames" placeholder="nombre1, nombre2, ...">
              <mat-hint>Separados por coma</mat-hint>
            </mat-form-field>
          </div>

          <!-- Fila 4: orden + paginación -->
          <div class="flex flex-wrap gap-4">
            <mat-form-field class="w-[180px]">
              <mat-label>Ordenar por</mat-label>
              <input matInput [(ngModel)]="orderBy" placeholder="dateCreated">
            </mat-form-field>
            <mat-form-field class="w-[120px]">
              <mat-label>Dirección</mat-label>
              <mat-select [(ngModel)]="orderDirection">
                <mat-option value="DESC">DESC</mat-option>
                <mat-option value="ASC">ASC</mat-option>
              </mat-select>
            </mat-form-field>
            <mat-form-field class="w-[90px]">
              <mat-label>Página</mat-label>
              <input matInput type="number" [(ngModel)]="page" min="0">
            </mat-form-field>
            <mat-form-field class="w-[110px]">
              <mat-label>Tamaño pág.</mat-label>
              <input matInput type="number" [(ngModel)]="pageSize" min="1" max="100">
            </mat-form-field>
          </div>

          <div>
            <button mat-raised-button color="primary" (click)="listFiles()" [disabled]="loading || !accessToken">
              <mat-spinner *ngIf="loading" diameter="18" class="inline-block mr-2"></mat-spinner>
              Buscar ficheros
            </button>
          </div>

          <!-- Tabla de resultados -->
          <div *ngIf="files.length > 0" class="overflow-x-auto">
            <p class="text-sm text-gray-500 mb-2">{{ totalFiles }} resultado(s)</p>
            <table class="min-w-full text-xs border-collapse">
              <thead>
                <tr class="bg-gray-100">
                  <th *ngFor="let key of fileKeys"
                      class="border border-gray-200 px-3 py-2 text-left font-semibold text-gray-600 whitespace-nowrap">
                    {{ key }}
                  </th>
                  <th class="border border-gray-200 px-3 py-2">Descargar</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let file of files" class="hover:bg-gray-50">
                  <td *ngFor="let key of fileKeys"
                      class="border border-gray-200 px-3 py-2 max-w-[200px] truncate text-gray-700">
                    {{ file[key] }}
                  </td>
                  <td class="border border-gray-200 px-3 py-2 text-center">
                    <button mat-icon-button (click)="downloadFile(file)" [disabled]="loading"
                            matTooltip="Descargar  →  /files/{id}/file">
                      <mat-icon class="!text-[18px]">download</mat-icon>
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          <div *ngIf="files.length === 0 && !loading && accessToken" class="text-sm text-gray-400 py-2">
            Sin resultados. Pulsa "Buscar ficheros" para consultar.
          </div>
        </div>
      </mat-expansion-panel>

      <!-- ── Sección 3: Prueba libre ── -->
      <mat-expansion-panel>
        <mat-expansion-panel-header>
          <mat-panel-title class="font-semibold">3. Probar endpoint</mat-panel-title>
          <mat-panel-description>Llamada libre — base: /cpaas-telekom/api/document-store</mat-panel-description>
        </mat-expansion-panel-header>

        <div class="flex flex-col gap-4 pt-2">
          <div class="text-xs text-gray-500 bg-gray-50 rounded p-3 space-y-1">
            <div><strong>Endpoints disponibles (OpenAPI):</strong></div>
            <div><code>GET /v2/files</code> — listar con paginación y filtros</div>
            <div><code>GET /files/&#123;id&#125;</code> — metadatos de un fichero</div>
            <div><code>GET /files/&#123;id&#125;/file</code> — descargar contenido binario</div>
            <div><code>GET /files/categories</code> — categorías disponibles</div>
            <div class="pt-1">
              Swagger:
              <a href="https://digitalservices.wholesale.telekom.com/api/document-store/open-api/swagger-ui/index.html"
                 target="_blank" rel="noopener" class="text-blue-500 underline">abrir</a>
            </div>
          </div>

          <div class="flex flex-wrap gap-4 items-start">
            <mat-form-field class="w-[120px]">
              <mat-label>Método</mat-label>
              <mat-select [(ngModel)]="customMethod">
                <mat-option value="GET">GET</mat-option>
                <mat-option value="POST">POST</mat-option>
                <mat-option value="DELETE">DELETE</mat-option>
              </mat-select>
            </mat-form-field>
            <mat-form-field class="flex-1 min-w-[220px]">
              <mat-label>Path (relativo a la base)</mat-label>
              <input matInput [(ngModel)]="customPath" placeholder="/v2/files">
            </mat-form-field>
            <mat-form-field class="flex-1 min-w-[220px]">
              <mat-label>Query params (k=v&amp;k2=v2)</mat-label>
              <input matInput [(ngModel)]="customQueryParams" placeholder="page=0&pageSize=10">
            </mat-form-field>
          </div>

          <div>
            <button mat-raised-button color="accent" (click)="testCustomEndpoint()"
                    [disabled]="loading || !accessToken">
              <mat-spinner *ngIf="loading" diameter="18" class="inline-block mr-2"></mat-spinner>
              Ejecutar
            </button>
          </div>
        </div>
      </mat-expansion-panel>

      <!-- ── Sección 4: Respuesta / Error ── -->
      <div *ngIf="lastResponse || lastError" class="flex flex-col gap-3">

        <div *ngIf="lastError" class="bg-red-50 border border-red-200 rounded p-4">
          <p class="text-xs font-semibold text-red-700 mb-1">Error</p>
          <pre class="text-red-600">{{ lastError }}</pre>
        </div>

        <div *ngIf="lastResponse" class="bg-gray-50 border border-gray-200 rounded p-4">
          <p class="text-xs font-semibold text-gray-600 mb-1">Respuesta</p>
          <pre class="text-gray-700">{{ lastResponse }}</pre>
        </div>
      </div>

    </div>
  </div>
  <div class="pointer-events-none absolute inset-px rounded-lg ring-1 shadow-sm ring-black/5 lg:rounded-[2rem]"></div>
</div>
